import React, { Fragment, PureComponent } from "react";
import { Row } from "react-bootstrap";
import ToolkitProvider from "react-bootstrap-table2-toolkit";
import moment from "moment";

import Tabla from "../../../components/UI/tabla/tablaSort";
import TimePicker from "./timePicker.jsx";

class tiemposIntfz extends PureComponent {
  constructor() {
    super();

    this.state = {
      columnasTiempos: [
        {
          dataField: "Estatus_Id",
          text: "Id",
          hidden: false,
          sort: true,
          editable: false,
          align: "left",
        },
        {
          dataField: "Nombre",
          text: "Nombre",
          hidden: false,
          sort: true,
          editable: false,
        },
        {
          dataField: "MaximoStr",
          text: "Máximo",
          hidden: false,
          sort: true,
          editable: true,
          validator: (newValue, row, column) => {
            if (newValue === "00:00:00") {
              return {
                valid: false,
                message: "Debe ingresar un Tiempo válido!",
              };
            }

            return true;
          },
          formatter: (cellContent, row) => <span>{cellContent}</span>,
          editorRenderer: (
            editorProps,
            value,
            row,
            column,
            rowIndex,
            columnIndex
          ) => <TimePicker {...editorProps} value={value} />,
        },
        {
          dataField: "Cambio",
          text: "Cambio",
          hidden: false,
          sort: true,
          editable: false,
          formatter: (cellContent, row) => (
            <span>{moment(cellContent).format("HH:mm:ss")}</span>
          ),
        },
      ],
      cellEdit: {},
      selectRow: {},
      rowStyle: {},
      keyField: "Estatus_Id",
    };
  }

  componentDidMount = async () => {
    const selectRow = {
      hideSelectColumn: true,
      clickToEdit: true,
    };

    this.setState({ selectRow });
  };

  render() {
    const { Datos, listaTiempos } = this.props;

    const { columnasTiempos, keyField, rowStyle, selectRow } = this.state;

    const rowEvents = {};

    const cellEdit = {
      mode: "click",
      blurToSave: true,
      autoSelectText: true,
      afterSaveCell: (oldValue, newValue, row, column) => {
        newValue !== oldValue &&
          this.props.ingresarDatos(newValue, row, column);
      },
    };
   
    return (
      <ToolkitProvider
        keyField="Estadus_Id"
        data={listaTiempos}
        columns={columnasTiempos}
        search
      >
        {(props) => (
          <Fragment>
            <div className="container mt-3">
              <div className="row">
                <div className="col-12">
                  <h1>{Datos.titulo}</h1>
                </div>
              </div>
            </div>
            <div className="container">
              <div className="botones mb-3">
                <Row className="mt-3">
                  <div className="col"></div>
                  <div className="col-3 text-right">
                   
                  </div>
                </Row>
              </div>
              <Tabla
                columnas={columnasTiempos}
                datos={listaTiempos}
                keyField={keyField}
                modo={cellEdit}
                rowStyle={rowStyle}
                selectRow={selectRow}
              />
            </div>
          </Fragment>
        )}
      </ToolkitProvider>
    );
  }
}

export default tiemposIntfz;
